export const Paths = {
  home: 'home',

  login: 'login',


  adminArea: 'adminArea',
  analystArea: 'analystArea',
  parentArea: 'parentArea',
  
  analystProfile: 'analystArea/profile',

  analystChildren: "analystArea/children", 
  analystForms: "analystArea/forms",      
  addChild: "analystArea/children/add",
  packages: "analystArea/packages",      


  childDetailsById: "analystArea/children/childDetails/:id",

  behaviorAnalysis: "analystArea/children/childDetails/:id/behavior-analysis", // נתיב לניתוח התנהגות
  childNotes: "analystArea/children/childDetails/:id/notes", // נתיב חדש להערות
  childForms: "analystArea/children/childDetails/:id/forms", // נתיב חדש לטפסים
  lessonSummaries: "analystArea/children/childDetails/:id/lesson-summaries", // נתיב חדש לסיכומי שיעור
  generalSummary: "analystArea/children/childDetails/:id/general-summary", // נתיב מתוקן לסיכום כללי
  completeProfile: "complete-profile",

  posts: 'posts',
  about: 'about',

};
